module.exports = __webpack_public_path__ + "static/img/icon_szh_wdfw_ycts.28770768.png";